import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledFinalFeedback = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  .feedback {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 20px;

    .title {
      color: white;
      margin-bottom: 0;
      &.success {
        color: ${Colors.success};
      }
    }

    .subtitle {
      text-align: center;
      color: ${Colors.border};
    }
  }
`;
